<template>
  <div
    :id="id"
    class="vegaContain"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  ></div>
</template>

<script>
import * as vega from "vega";
import apiAxios from "@/config/apiAxios";
export default {
  name: "annt",
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "320px",
    },
  },
  components: {},
  data() {
    return {
      vegaDefaultConfig: {
        $schema: "https://vega.github.io/schema/vega/v5.json",
        description: "A basic stacked bar chart example.",
        width: 500,
        height: 320,
        padding: 0,
        autosize: "fit",
        title: {
          color: "#fff",
          subtitleColor: "#fff",
          text: "发行上市审核全景",
          anchor: "middle",
          fontSize: 16,
          frame: "group",
          offset: 4,
        },
        signals: [
          {
            name: "width",
            update: "containerSize()[0]",
            on: [
              {
                events: {
                  source: "window",
                  type: "resize",
                },
                update: "containerSize()[0]",
              },
            ],
          },
          {
            name: "height",
            update: "containerSize()[1]",
            on: [
              {
                events: {
                  source: "window",
                  type: "resize",
                },
                update: "containerSize()[1]",
              },
            ],
          },
        ],
        data: [
          {
            name: "board_now",
            values: [
              {
                上市板块: "上交所",
                顺序: "1",
                类别: "已受理",
                数量: "149",
              },
              {
                上市板块: "上交所",
                顺序: "2",
                类别: "已问询",
                数量: "7",
              },
              {
                上市板块: "上交所",
                顺序: "3",
                类别: "上市委会议",
                数量: "0",
              },
              {
                上市板块: "上交所",
                顺序: "4",
                类别: "提交注册",
                数量: "0",
              },
              {
                上市板块: "上交所",
                顺序: "5",
                类别: "注册结果",
                数量: "0",
              },
              {
                上市板块: "上交所",
                顺序: "6",
                类别: "中止",
                数量: "0",
              },
              {
                上市板块: "上交所",
                顺序: "7",
                类别: "终止",
                数量: "218",
              },
              {
                上市板块: "上交所科创板",
                顺序: "1",
                类别: "已受理",
                数量: "3",
              },
              {
                上市板块: "上交所科创板",
                顺序: "2",
                类别: "已问询",
                数量: "73",
              },
              {
                上市板块: "上交所科创板",
                顺序: "3",
                类别: "上市委会议",
                数量: "26",
              },
              {
                上市板块: "上交所科创板",
                顺序: "4",
                类别: "提交注册",
                数量: "33",
              },
              {
                上市板块: "上交所科创板",
                顺序: "5",
                类别: "注册结果",
                数量: "540",
              },
              {
                上市板块: "上交所科创板",
                顺序: "6",
                类别: "中止",
                数量: "9",
              },
              {
                上市板块: "上交所科创板",
                顺序: "7",
                类别: "终止",
                数量: "188",
              },
              {
                上市板块: "北交所",
                顺序: "1",
                类别: "已受理",
                数量: "1",
              },
              {
                上市板块: "北交所",
                顺序: "2",
                类别: "已问询",
                数量: "43",
              },
              {
                上市板块: "北交所",
                顺序: "3",
                类别: "上市委会议",
                数量: "6",
              },
              {
                上市板块: "北交所",
                顺序: "4",
                类别: "提交注册",
                数量: "9",
              },
              {
                上市板块: "北交所",
                顺序: "5",
                类别: "注册结果",
                数量: "173",
              },
              {
                上市板块: "北交所",
                顺序: "6",
                类别: "中止",
                数量: "14",
              },
              {
                上市板块: "北交所",
                顺序: "7",
                类别: "终止",
                数量: "105",
              },
              {
                上市板块: "深交所主板",
                顺序: "1",
                类别: "已受理",
                数量: "102",
              },
              {
                上市板块: "深交所主板",
                顺序: "2",
                类别: "已问询",
                数量: "3",
              },
              {
                上市板块: "深交所主板",
                顺序: "3",
                类别: "上市委会议",
                数量: "0",
              },
              {
                上市板块: "深交所主板",
                顺序: "4",
                类别: "提交注册",
                数量: "0",
              },
              {
                上市板块: "深交所主板",
                顺序: "5",
                类别: "注册结果",
                数量: "0",
              },
              {
                上市板块: "深交所主板",
                顺序: "6",
                类别: "中止",
                数量: "0",
              },
              {
                上市板块: "深交所主板",
                顺序: "7",
                类别: "终止",
                数量: "0",
              },
              {
                上市板块: "深交所创业板",
                顺序: "1",
                类别: "已受理",
                数量: "6",
              },
              {
                上市板块: "深交所创业板",
                顺序: "2",
                类别: "已问询",
                数量: "133",
              },
              {
                上市板块: "深交所创业板",
                顺序: "3",
                类别: "上市委会议",
                数量: "98",
              },
              {
                上市板块: "深交所创业板",
                顺序: "4",
                类别: "提交注册",
                数量: "57",
              },
              {
                上市板块: "深交所创业板",
                顺序: "5",
                类别: "注册结果",
                数量: "450",
              },
              {
                上市板块: "深交所创业板",
                顺序: "6",
                类别: "中止",
                数量: "11",
              },
              {
                上市板块: "深交所创业板",
                顺序: "7",
                类别: "终止",
                数量: "315",
              },
            ],
            transform: [
              {
                type: "formula",
                expr: "if(datum.上市板块=='上交所','上交所主板',datum.上市板块)",
                as: "上市板块",
              },
            ],
          },
          {
            name: "board_now_all",
            source: ["board_now"],
            transform: [
              {
                type: "aggregate",
                fields: ["数量"],
                groupby: ["上市板块"],
                ops: ["sum"],
                as: ["数量"],
              },
            ],
          },
          {
            name: "exchange_now",
            source: ["board_now"],
            transform: [
              {
                type: "filter",
                expr: "datum.上市板块!='北交所'",
              },
              {
                type: "formula",
                expr: "slice(datum.上市板块,0,3)",
                as: "上市板块",
              },
              {
                type: "aggregate",
                fields: ["数量"],
                groupby: ["上市板块", "顺序", "类别"],
                ops: ["sum"],
                as: ["数量"],
              },
            ],
          },
          {
            name: "exchange_now_all",
            source: ["exchange_now"],
            transform: [
              {
                type: "aggregate",
                fields: ["数量"],
                groupby: ["上市板块"],
                ops: ["sum"],
                as: ["数量"],
              },
            ],
          },
          {
            name: "market_now",
            source: ["board_now"],
            transform: [
              {
                type: "aggregate",
                fields: ["数量"],
                groupby: ["顺序", "类别"],
                ops: ["sum"],
                as: ["数量"],
              },
              {
                type: "formula",
                expr: "'全市场'",
                as: "上市板块",
              },
            ],
          },
          {
            name: "market_now_all",
            source: ["market_now"],
            transform: [
              {
                type: "aggregate",
                fields: ["数量"],
                groupby: ["上市板块"],
                ops: ["sum"],
                as: ["数量"],
              },
            ],
          },
          {
            name: "now_all",
            source: ["board_now_all", "exchange_now_all", "market_now_all"],
          },
          {
            name: "market",
            values: [
              {
                上市板块: "全市场",
              },
              {
                上市板块: "上交所",
              },
              {
                上市板块: "上交所主板",
              },
              {
                上市板块: "上交所科创板",
              },
              {
                上市板块: "深交所",
              },
              {
                上市板块: "深交所主板",
              },
              {
                上市板块: "深交所创业板",
              },
              {
                上市板块: "北交所",
              },
            ],
            transform: [
              {
                type: "formula",
                expr: "1",
                as: "order",
              },
              {
                type: "identifier",
                as: "id",
              },
              {
                type: "lookup",
                from: "now_all",
                key: "上市板块",
                fields: ["上市板块"],
                values: ["数量"],
                as: ["数量"],
                default: 0,
              },
            ],
          },
          {
            name: "market_all_now",
            source: ["board_now", "exchange_now", "market_now"],
            transform: [
              {
                type: "lookup",
                from: "market",
                key: "上市板块",
                fields: ["上市板块"],
                values: ["数量", "id"],
                as: ["总量", "总顺序"],
                default: 0,
              },
              {
                type: "stack",
                groupby: ["上市板块"],
                sort: {
                  field: "顺序",
                },
                field: "数量",
              },
              {
                type: "formula",
                expr: "datum.y0/datum.总量*100",
                as: "ny0",
              },
              {
                type: "formula",
                expr: "datum.y1/datum.总量*100",
                as: "ny1",
              },
            ],
          },
        ],
        scales: [
          {
            name: "xscale",
            type: "band",
            range: "width",
            domain: {
              data: "market_all_now",
              field: "上市板块",
              sort: {
                op: "sum",
                field: "总顺序",
              },
            },
          },
          {
            name: "yscale",
            type: "linear",
            range: "height",
            nice: true,
            zero: true,
            domain: {
              data: "market_all_now",
              field: "总量",
            },
          },
          {
            name: "color",
            type: "ordinal",
            range: "category",
            domain: {
              data: "market_all_now",
              field: "类别",
            },
          },
        ],
        legends: [
          {
            fill: "color",
            title: "审核状态",
            titleColor: "#fff",
                labelColor: "#fff",
            offset: 0,
            encode: {
              symbols: {
                update: {
                  fillOpacity: { value: 0.8 },
                  stroke: { value: "transparent" },

                },
              },
            },
          },
        ],
        axes: [
          {
            orient: "bottom",
            scale: "xscale",
            zindex: 1,
            labelPadding: 10,
            labelColor: "#fff",
          },
          {
            orient: "left",
            scale: "yscale",
            zindex: 1,
            labelPadding: 10,
            labelColor: "#fff",
          },
        ],

        marks: [
          {
            type: "rect",
            from: {
              data: "market_all_now",
            },
            encode: {
              enter: {
                fill: {
                  scale: "color",
                  field: "类别",
                },
                tooltip: {
                  signal: "datum.类别+datum.数量+'家'",
                },
              },
              update: {
                x: {
                  scale: "xscale",
                  field: "上市板块",
                },
                width: {
                  scale: "xscale",
                  band: 1,
                  offset: -1,
                },
                y: {
                  scale: "yscale",
                  field: "y0",
                },
                y2: {
                  scale: "yscale",
                  field: "y1",
                },
                fillOpacity: {
                  value: 1,
                },
              },
              hover: {
                fillOpacity: {
                  value: 0.5,
                },
              },
            },
          },
        ],
      },
      vegaView: false,
      loading: true,
    };
  },
  methods: {
    vegaInit() {
      // let width = document.body.clientWidth/3 - 100;
      let width = document.getElementById(this.id).clientWidth;
      let height = document.getElementById(this.id).clientHeight;
      // let width = document.body.clientWidth/3 -100;
      this.vegaDefaultConfig.width = width;
      this.vegaDefaultConfig.height = height;

      let aa = vega.parse(this.vegaDefaultConfig);
      var view = new vega.View(vega.parse(this.vegaDefaultConfig))
        .renderer("svg")
        .initialize("#" + this.id)
        .hover()
        .run();
      this.loading = false;

      this.vegaView = view;
    },
  },
  mounted() {
    this.vegaInit();
  },
};
</script>

<style lang="less" scoped>
.vegaContain{
    padding: 5px;
    // border: solid 1px;
    margin: 10px;
}
</style>
